exports.ActionType = {
   EDIT: "edit",
   DUPLICATE: "duplicate",
   DELETE: "delete",
   SELECT_UNIT: "selectUnit",
   CREATE_PATHWAY: "createPathway",
   CREATE_PATHWAY_WITH_DOMAIN: "createPathwayDomain",
   CREATE_DOMAIN: "createDomain",
   SELECT_DOMAIN: "selectDomain",
   DESELECT_DOMAIN: "deselectDomain",
   CHANGE_STEP: "changeStep",
   NEXT_STEP: "nextStep",
   PREVIOUS_STEP: "previousStep",
   COMPLETE_STEP: "completeStep",
   SELECT_AREA: "selectArea",
   DESELECT_AREA: "deselectArea",
   CREATE_AREA: "createArea",
   CHANGE_TYPE: "changeType",
   COMPLETE_TYPE: "completeType",
   ADD_INDICATOR: "addIndicator",
   CREATE_INDICATOR: "createIndicator",
   CREATE_MY_INDICATOR: "createMyIndicator",
   CREATE_INDICATOR_WITH_TYPE: "createIndicatorWithType",
   CREATE_MY_INDICATOR_WITH_TYPE: "createMyIndicatorWithType",
   EDIT_INDICATOR: "editIndicator",
   EDIT_MY_INDICATOR: "editMyIndicator",
   DELETE_INDICATOR: "deleteIndicator",
   DUPLICATE_INDICATOR: "duplicateIndicator",
   ADD_MULTIPLE_INDICATORS: "addMultipleIndicators",
   DELETE_MULTIPLE_INDICATORS: "deleteMultipleIndicators",
   SAVE_PATHWAY: "savePathway",
   EDIT_PATHWAY: "editPathway",
   DELETE_PATHWAY: "deletePathway",
   DUPLICATE_PATHWAY: "duplicatePathway",
   CHANGE_NAME_PATHWAY: "nameChangePathway",
   EDIT_SAVED_INDICATOR: "editSavedIndicator",
   DUPLICATE_SAVED_INDICATOR: "duplicateSavedIndicator",
   DELETE_SAVED_INDICATOR: "deleteSavedIndicator",
   REFRESH_DONE_PATHWAY_TABLE: "refreshDonePathwayTable",
   UPDATE_SUBSTEPS: "updateSubsteps",
   SHOW_ALERT: "showAlert",
   SHOW_CONFIRM: "showConfirm",
   CONFIRMED_INDICATOR_DELETE: "confirmedIndicatorDelete",
   CONFIRMED_MULTI_INDICATOR_DELETE: "confirmedMultiIndicatorDelete",
   CONFIRMED_CHECKBOX_RESET: "confirmedCheckboxReset",
   CONFIRMED_INDICATOR_EDIT: "confirmedIndicatorEdit",
   CONFIRMED_INDICATOR_CREATE: "confirmedIndicatorCreate",
   RESET_CONFIRMED_ACTION: "resetConfirmedAction"
};

exports.ReportingNeed = {
   OPERATIONS: "Operations",
   CHANGING_THE_WORLD: "Changing The World"
};

const Domain = {
   ARTS: "Arts and Culture",
   COLLABORATION: "Collaboration",
   COMMUNITY: "Community, Connections and Place-based Development",
   WORK: "Decent Work and Employment",
   ENVIRONMENT: "Environmental Sustainability and Climate Resilience",
   FIRST_NATIONS: "First Nations' Knowledge and Culture",
   HEALTH: "Health and Wellbeing",
   HOUSING: "Housing and Accommodation",
   IMPROVING_SYSTEMS: "Improving Systems, Organisations, and Practices",
   IMPROVING_SYSTEMS_ALT: "Improving Systems, Organisations and Practices",
   GOVERNANCE: "Organisational Governance",
   EQUITY: "Representation and Equity in Governance",
   EDUCATION: "Training and Education",
   FINANCIAL_MANAGEMENT: "Financial Management",
   PEOPLE_MANAGEMENT: "People Management",
   SALES_MARKETING: "Sales & Marketing",
   SALES_MARKETING_ALT: "Sales and Marketing",
   DIGITAL_INCLUSION: "Digital Inclusion"
};

exports.Domain = Domain;

exports.ALL_DOMAINS = [
   Domain.ARTS,
   Domain.COLLABORATION,
   Domain.COMMUNITY,
   Domain.WORK,
   Domain.ENVIRONMENT,
   Domain.FIRST_NATIONS,
   Domain.HEALTH,
   Domain.HOUSING,
   Domain.IMPROVING_SYSTEMS,
   Domain.IMPROVING_SYSTEMS_ALT,
   Domain.GOVERNANCE,
   Domain.EQUITY,
   Domain.EDUCATION,
   Domain.FINANCIAL_MANAGEMENT,
   Domain.PEOPLE_MANAGEMENT,
   Domain.SALES_MARKETING,
   Domain.SALES_MARKETING_ALT,
   Domain.DIGITAL_INCLUSION
];

exports.CUSTOM_DOMAIN_VALUE = "CUSTOM";
exports.CUSTOM_DOMAIN_LABEL = "Custom Domain"

exports.CUSTOM_OUTCOME_AREA_VALUE = "CUSTOM";
exports.CUSTOM_OUTCOME_AREA_LABEL = "Custom Outcome Area"

exports.LOADING_MESSAGE = "Loading...";

exports.INDICATOR_STEPS = [
   { 
      title: "Choose domain", 
      completed: false,
      substeps: [], 
   },
   { 
      title: "Select outcome area", 
      completed: false,
      substeps: [], 
   },
   { 
      title: "Add indicators", 
      completed: false,
      substeps: [
         {
            type: "Input",
            title: "Select Input Indicators",
            subtitle: "Select your input indicator/s and then click \"Next\" to select outputs",
            tip: "Inputs are specific resources that the program/enterprise/organisation uses to address the overall aim",
            tipAfter: "title",
            iconName: "DocumentArrowDown",
            buttonText: "Input Indicators",
            completed: false
         },
         {
            type: "Output",
            title: "Select Output Indicators",
            subtitle: "Select your output indicator/s and then click \"Next\" to select outcomes",
            tip: "Outputs are tangible things that are done (activities and products) by the program/enterprise/organisation to achieve the desired outcomes.",
            tipAfter: "title",
            iconName: "DocumentArrowUp",
            buttonText: "Output Indicators",
            completed: false
         },
         {
            type: "Outcome",
            title: "Select Outcome Indicators",
            subtitle: "Select your outcome indicator/s and then click \"Next\" to review",
            tip: "Outcomes are short to medium term effects of the program/enterprise/organisation and can be positive or negative. ",
            tipAfter: "title",
            iconName: "DocumentChartBar",
            buttonText: "Outcome Indicators",
            completed: false
         },
      ],  
   },
   { 
      title: "View/edit indicators", 
      completed: false,
      substeps: [], 
   },
];

exports.IndicatorType = {
   INPUT: "Input", 
   ACTIVITY: "Activity", 
   OUTPUT: "Output", 
   OUTCOME: "Outcome", 
   IMPACT: "Impact",
   NONE: ""
};

exports.Format = {
   NUMBER: "#",
   PERCENT: "%",
   CURRENCY: "$",
   TEXT: "*",
   NONE: ""
}

exports.CheckFields = [
   "title",
   "reportingNeed",
   "domain",
   "outcomeArea",
   "indicatorType",
   "description",
   "frequency",
   "cohort",
   "format",
   "source"
];

exports.PathwayTableAction = {
   Pathway: {
      EDIT: true,
      DUPLICATE: false,
      DELETE: true
   },
   Indicator: {
      EDIT: true,
      DUPLICATE: true,
      DELETE: true
   }
};

exports.TooltipType = {
    DOMAIN: "Domain",
    OUTCOME_AREA: "Outcome Area"
};

exports.PATHWAY_EXISTS_ALERT_DELAY = 500;

exports.DEFAULT_CUSTOM_DOMAIN_ICON = "Asterisk01";